import React from "react";
import { connect } from 'react-redux';
// import { Link } from 'react-router-dom';
import { numberFunction } from '_helpers';
import {
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    Row,
    Col,
    Collapse,
    ListGroupItem
    // UncontrolledDropdown,
    // DropdownToggle,
    // DropdownMenu,
    // DropdownItem,
    // Table,
} from "reactstrap";
import ReactTable from 'react-table'
import * as moment from 'moment';

import { dateFromISO8601 } from '_helpers';
import { Link } from 'react-router-dom';
import noImage from "assets/img/img-livenyte/LiveNyteNoImage.jpg";



class ReviewForIdTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openedCollapses: [],
            // reviews: [] 
            // [revId, isSender, message, rating, time, unread, spId, spName, imageUrl, eventId]
        }
    }

    componentDidMount() {

    }


    normalizeReview = (review) => ({
        review_id: review.id,
        message: review.review,
        score: review.rating,
        date: review.date,
        other_member_id: review.s_id,
        other_name: review.name,
        other_image: review.photo,
        event_id: review.event_id,
        time_zone: review.time_zone,
        is_business: review.is_business,
        is_specialist: review.is_specialist,
        is_agency: review.is_agency,
    });


    render() {
        const user = JSON.parse(localStorage.getItem('user'));
        // const eventsName = this.props.eventsName
        const { reviews } = this.props

        const displayReviews = reviews.sort((a, b) => (moment(a.date).isBefore(b.date))).map(this.normalizeReview);

        console.log("reviews", reviews, displayReviews)
        // console.log("eventsName", eventsName)
        console.log("openedCollapses", this.state.openedCollapses)
        return (
            <Row>
                <Col xs={12} className="px-0">
                    <div className='no-border-bottom-rt-tr-group'>

                        <ReactTable
                            data={displayReviews}
                            filterable
                            sortable
                            showPagination={false}
                            minRows={0}
                            columns={[
                                {
                                    Header: "Reviews",
                                    accessor: "date",
                                    className: "wrap-cell",
                                    Filter: ({ filter, onChange }) => (
                                        <input
                                            type="text"
                                            placeholder="Search for a name"
                                            value={filter ? filter.value : ""}
                                            onChange={e => onChange(e.target.value)}
                                            style={{ width: "100%" }}
                                        />
                                    ),
                                    filterMethod: (filter, row) => {
                                        const review = row._original;
                                        const value = filter.value.toLowerCase();

                                        const message = review.message?.toLowerCase() || "";
                                        const otherName = review.other_name?.toLowerCase() || "";
                                        // const eventName =
                                        //     eventsName?.[review.event_id]?.name?.toLowerCase() || "";
                                        return (
                                            message.includes(value) ||
                                            otherName.includes(value)
                                            // eventName.includes(value)
                                        );
                                    },
                                    Cell: props => {
                                        const review = props.original;
                                        const profilePath = review.is_specialist
                                            ? `/dash/c/${numberFunction(parseInt(review.other_member_id, 10))}`
                                            : `/dash/b/${numberFunction(parseInt(review.other_member_id, 10))}`;

                                        return (
                                            <ListGroupItem
                                                className={`list-group-item-action`}
                                            >
                                                {/* Main Row */}
                                                <Row className="align-items-center">

                                                    <Col className="col-auto">
                                                        <Link to={{ pathname: profilePath }}>
                                                            <img
                                                                className="avatar rounded-circle"
                                                                src={review.other_image}
                                                                alt={review.other_name}
                                                                onError={(e) => {
                                                                    e.target.onerror = null;
                                                                    e.target.src = noImage;
                                                                }}
                                                            />
                                                        </Link>
                                                    </Col>

                                                    {/* Center content */}
                                                    <Col className="min-width-0 ml--2">
                                                        <Link to={{ pathName: profilePath }}>
                                                            <h4 className="mb-0 text-sm text-wrap">
                                                                {/* {eventsName?.[review.event_id]?.name || ""} */}
                                                                {review.otherName}
                                                            </h4>

                                                            <p className="text-sm mb-0 text-wrap">
                                                                <span className="font-weight-light table-text">
                                                                    {review.message}
                                                                </span>
                                                            </p>

                                                            <hr className="my-2 mr-0" />
                                                        </Link>
                                                    </Col>

                                                    {/* Right actions / score */}
                                                    <Col xs="auto" className="text-right pl-1">
                                                        <div className="d-flex flex-column align-items-center">
                                                            <h1 className="">
                                                                {review.score}
                                                            </h1>

                                                            {/* {review.unread && (
                                <span className="badge badge-info mt-1">
                                  New
                                </span>
                              )} */}
                                                        </div>
                                                    </Col>
                                                </Row>

                                                {/* Footer row */}
                                                <Row>
                                                    <Col xs={12} className="text-left">
                                                        <Link to={{ pathname: profilePath }}>
                                                            <div className="ml-6">
                                                                <div className="surtitle h5 pb-1">
                                                                    {review.other_name}
                                                                </div>
                                                                <small className="text-muted surtitle">
                                                                    {dateFromISO8601(
                                                                        review.date,
                                                                        "America/Los_Angeles",
                                                                        "LLL"
                                                                    )}
                                                                </small>

                                                            </div>
                                                        </Link>
                                                    </Col>
                                                </Row>
                                            </ListGroupItem>
                                        );
                                    }
                                }
                            ]}
                        />
                    </div>
                </Col>
            </Row >
        );
    }
}

function mapStateToProps(state) {
    return {
    };
}
const connectedReviewForIdTable = connect(mapStateToProps)(ReviewForIdTable);

export { connectedReviewForIdTable as ReviewForIdTable };
